module.exports = __webpack_public_path__ + "static/media/good.24d256df.png";